import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { Col } from '@amzn/atoz-web/Col';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { View } from '@amzn/atoz-web/View';
import { PageContainer } from '@amzn/atoz-web/PageContainer';
import { TriggerButton } from '@amzn/atoz-web/Helpers';
import { ExpanderContent } from '@amzn/atoz-web/Expander';
import { useBreakpoints } from '@amzn/atoz-web/Responsive';
import { SpinnerOverlay } from '../../features/shared';
export var FindShiftsPageLayout = function (_a) {
    var pageHeader = _a.pageHeader, shiftCards = _a.shiftCards, shiftOpportunityCards = _a.shiftOpportunityCards, selectedDate = _a.selectedDate, daySelector = _a.daySelector, shiftFilters = _a.shiftFilters, numOfClaimedShifts = _a.numOfClaimedShifts, _b = _a.isRefetching, isRefetching = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var _c = useState(true), showClaimedShifts = _c[0], setShowClaimedShifts = _c[1];
    var matches = useBreakpoints().matches;
    var headerText = matches.s
        ? t('shift_management_views_FindShiftsPageLayout_scheduledShiftsHeader_mobile', {
            count: numOfClaimedShifts
        })
        : t('shift_management_views_FindShiftsPageLayout_scheduledShiftsHeader_web', {
            count: numOfClaimedShifts,
            selectedDate: selectedDate.toLocaleString({
                weekday: 'short',
                month: 'short',
                day: 'numeric'
            })
        });
    var shiftFiltersAsButton = matches.s || matches.m;
    return (React.createElement(FindShiftsPageContainer, { dataTestId: "FindShiftsPageLayout", backgroundColor: "neutral0" },
        pageHeader,
        daySelector,
        React.createElement(Row, { flex: 1, gridGap: "S300", justifyContent: "space-between" },
            React.createElement(View, { width: '100%' },
                React.createElement(SpinnerOverlay, { isLoading: isRefetching },
                    React.createElement(ClaimedShiftsCol, { flex: 1 },
                        React.createElement(Row, { gridGap: "S300" },
                            React.createElement(ClaimedShiftsColHeader, { flex: 1, alignItems: "center", dataTestId: "ClaimedShiftsColHeader", onClick: function () {
                                    setShowClaimedShifts(function (prev) { return !prev; });
                                } },
                                React.createElement(HeaderText, null, headerText),
                                numOfClaimedShifts > 0 && (React.createElement(ExpandButton, { dataTestId: "ClaimedShiftsExpandButton", isExpanded: showClaimedShifts, iconAltText: t('shift_management_views_FindShiftsPageLayout_scheduledShiftsExpandButton_altText') })))),
                        React.createElement(ExpanderContent, { dataTestId: "ClaimedShiftsList", isExpanded: showClaimedShifts, shouldAnimateImmediately: true },
                            React.createElement(ClaimedShiftList, { isExpanded: showClaimedShifts, flex: 1, gridGap: "S300" }, shiftCards))),
                    shiftFiltersAsButton && (React.createElement(Row, { justifyContent: "flex-end", margin: "S200" },
                        React.createElement(View, null, shiftFilters))),
                    React.createElement(UnclaimedShiftsCol, { flex: 1, gridGap: "S300" }, shiftOpportunityCards ? (shiftOpportunityCards) : (React.createElement(NoOpportunitiesMessage, { gridGap: "S300", dataTestId: "NoOpportunitiesMessage" },
                        React.createElement(Text, { fontWeight: "bold" }, t('shift_management_views_FindShiftsPageLayout_noOpportunities')),
                        React.createElement(Text, null, t('shift_management_views_FindShiftsPageLayout_checkBackLater'))))))),
            !shiftFiltersAsButton && (React.createElement(View, { minWidth: '275px' }, shiftFilters)))));
};
var FindShiftsPageContainer = styledWithTheme(PageContainer)("\n    margin: 0;\n    padding: 0;\n    min-height: 100vh;\n");
var ClaimedShiftList = styledWithTheme(Col)(function (_a) {
    var theme = _a.theme, isExpanded = _a.isExpanded;
    return "\n        padding-top: ".concat(isExpanded ? theme.selectors.space('S200') : 0, "px;\n    ");
});
var ClaimedShiftsColHeader = styledWithTheme(Row)("\n    cursor: pointer;\n");
var HeaderText = styledWithTheme(View)(function (_a) {
    var theme = _a.theme;
    return "\n        font-weight: ".concat(theme.selectors.fontWeight('bold'), ";\n        font-size: ").concat(theme.selectors.fontSize('T200'), ";\n        width: 100%;\n    ");
});
var ExpandButton = styledWithTheme(TriggerButton)(function (_a) {
    var theme = _a.theme;
    return "\n        color: ".concat(theme.selectors.color('neutral70'), ";\n        &:focus:before {\n            border: none;\n        }\n        &:focus, &:hover, &:not(:hover) {\n            border: none;\n        }\n    ");
});
var ClaimedShiftsCol = styledWithTheme(Col)(function (_a) {
    var theme = _a.theme;
    return "\n        margin-bottom: ".concat(theme.selectors.space('S300'), "px;\n        padding: ").concat(theme.selectors.space('S200'), "px;\n        background-color: ").concat(theme.selectors.color('neutral05'), ";\n        box-shadow: 0px 1px 0px ").concat(theme.selectors.color('neutral30'), ";\n    ");
});
var UnclaimedShiftsCol = styledWithTheme(Col)(function (_a) {
    var theme = _a.theme;
    return "\n        padding: 0 ".concat(theme.selectors.space('S300'), "px;\n    ");
});
var NoOpportunitiesMessage = styledWithTheme(Col)("\n    text-align: center;\n");
